import React, { useState } from "react";

import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "app/components/ui/tabs";

const letters = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
];

const travellingData = [
  "Albania",
  "Algeria",
  "Andorra",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahrain",
  "Belarus",
  "Belgium",
  "Bosnia and Herzegovina",
  "Brazil",
  "Bulgaria",
  "Cambodia",
  "Canada",
  "Croatia",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Estonia",
  "Faroe Islands",
  "Finland",
  "France",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Ireland",
  "Israel",
  "Italy",
  "Kazakhstan",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Latvia",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao China",
  "Macedonia",
  "Malaysia",
  "Malta",
  "Mexico",
  "Moldova",
  "Montenegro",
  "Netherlands",
  "New Zealand",
  "Norway",
  "Oman",
  "Pakistan",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Reunion",
  "Romania",
  "Russian Federation",
  "Serbia",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Spain",
  "Sri Lanka",
  "Sweden",
  "Switzerland",
  "Taiwan",
  "Thailand",
  "Tunisia",
  "Turkey",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uzbekistan",
];

export const Travelling = () => {
  const [tab, setTab] = useState("A");

  return (
    <section
      id="international-roaming"
      className="px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12 pb-8 sm:pb-12 md:pb-14 lg:pb-[4.75rem]"
    >
      <div className="w-full max-w-[82.5rem] mx-auto">
        <div className="mb-3 text-center sm:mb-4 md:mb-5 lg:mb-7">
          <h2 className="font-mobile text-[#1D1D1B] text-[clamp(1.5rem,calc(2.5vw+1rem),3.125rem)] font-normal leading-tight md:leading-snug lg:leading-[4.125rem] mb-0.5">
            Travelling to one of these places? <br />
            You're covered with our Multi Network Plans.
          </h2>
          <p className="text-[#1D1D1B] text-[0.925rem] sm:text-base lg:text-lg font-normal leading-[1.375rem] sm:leading-6 lg:leading-7">
            All plans include data, calls, and texts within the US, Canada, and
            Mexico at no additional cost.
          </p>
        </div>
        <Tabs
          defaultValue="A"
          value={tab}
          onValueChange={setTab}
          className="flex flex-col justify-center gap-5 sm:gap-6 lg:gap-7 2xl:gap-[4.75rem] w-full"
        >
          <TabsList className="flex-wrap gap-x-5 gap-y-3.5 sm:gap-x-[1.375rem] sm:gap-y-[1.125rem] md:gap-6 lg:gap-[1.625rem] h-auto mx-auto">
            {letters.map((letter) => (
              <TabsTrigger
                key={letter}
                value={letter}
                className="data-[state=active]:bg-transparent rounded-none p-0 data-[state=active]:shadow-none text-[#A8A8A8] data-[state=active]:text-[#FE4D01] text-sm sm:text-[0.925rem] lg:text-base font-medium leading-normal underline decoration-solid [text-decoration-skip-ink:auto] [text-decoration-thickness:auto] [text-underline-offset:auto] [text-underline-position:from-font]"
              >
                {letter}
              </TabsTrigger>
            ))}
          </TabsList>
          {letters.map((letter) => (
            <TabsContent
              key={letter}
              value={letter}
              className="sm:px-[0.85rem] mt-0 sm:mx-auto"
            >
              <div className="flex flex-col sm:flex-row gap-7 sm:gap-24 md:gap-16 lg:gap-28 xl:gap-40 2xl:gap-[13.81rem]">
                <h3 className="text-[#1F1F1F] text-4xl sm:text-[2.375rem] md:text-[2.5rem] lg:text-[2.75rem] font-semibold leading-9 sm:leading-[2.375rem] md:leading-10 lg:leading-[2.75rem] mb-5">
                  {letter}
                </h3>
                <div className="grid grid-cols-2 [@media(min-width:540px)]:grid-cols-3 sm:!grid-cols-2 md:!grid-cols-3 gap-x-[3.62rem] sm:gap-x-20 lg:gap-x-24 2xl:gap-x-[6.37rem] gap-y-5 sm:gap-y-[1.375rem] md:gap-y-6 lg:gap-y-[1.56rem] [@media(max-width:540px)]:max-w-80">
                  {travellingData
                    .filter((item) => item.charAt(0).toUpperCase() === letter)
                    .map((item) => (
                      <span
                        key={item}
                        className="inline-block text-[#1F1F1F] text-sm sm:text-[0.925rem] lg:text-base font-normal leading-normal"
                      >
                        {item}
                      </span>
                    ))}
                </div>
              </div>
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </section>
  );
};
